// Copyright (c) 2026 Dyna Robotics, Inc. All rights reserved.
// Dyna Robotics Proprietary and Confidential.
// Unauthorized copying, use, or distribution is prohibited.
// SPDX-License-Identifier: LicenseRef-Dyna-Internal

/**
 * 全部展开 / 全部折叠 for a tree table (design doc §10.6).
 *
 * Disabled while the table is filtered or searched: the matches are shown wherever they
 * sit in the tree, and a fold that hid one would make the search look as if it had found
 * less than it did.
 */

import { useTranslation } from "react-i18next";

interface Props {
  levels: number;
  disabled: boolean;
  /** null opens everything; 1 folds the table down to its top level. */
  onLevel: (level: number | null) => void;
}

export function FoldControls({ levels, disabled, onLevel }: Props) {
  const { t } = useTranslation();
  if (levels < 2) return null;
  const title = disabled ? t("tree.disabledWhileFiltered") : undefined;
  return (
    <div className="chip-group" role="group" aria-label={t("tree.levels")} title={title}>
      <button type="button" className="chip" disabled={disabled} onClick={() => onLevel(null)}>
        {t("tree.expandAll")}
      </button>
      <button type="button" className="chip" disabled={disabled} onClick={() => onLevel(1)}>
        {t("tree.collapseAll")}
      </button>
    </div>
  );
}
